<template>
  <div>
    <div v-for="item in data" :key="item.id">
      <table>
        <tr>
          <td>
            <strong style="cursor: pointer;" @click="item.lead ? openPage('/leads/detail?id=' + item.lead.id + '&page=' + 1 + '&is_sales_planner=1') : ''"> {{item.lead.first_name}} {{item.lead.last_name}} </strong>

          </td>
          <td colspan="2" class="p-2">
            {{item.leads_activities_status.id == 4 ?  'Verified' : 'Not Verified' }}
          </td>
        </tr>
        <tr>
          <td class="p-2">
            <!-- {{item.leads_activities_type.name}} -->
            {{ item.leads_activities_type_NEW }}
          </td>
          <td class="p-2">
            {{item.appointment_status ? 'Show' : 'Not Show' }}
          </td>
          <td class="p-2">
            {{item.lead.member? (item.lead.member.membership ? 'Join' : 'Not Join') : 'Not Join'}}
          </td>
        </tr>
        <template v-if="item.leads_activities_type_NEW == 'Fresh Appoitment'">
          <tr>
            <td class="p-2">
              Re-Schedule
            </td>
            <td class="p-2">
              {{ item.total_reschedule }}
            </td>
            <td class="p-2"></td>
          </tr>
        </template>
        <template v-if="item.leads_activities_type_NEW == 'Miss Guest'">
          <tr>
            <td class="p-2">
              MG
            </td>
            <td class="p-2">
              {{ item.total_missguest }}
            </td>
            <td class="p-2"></td>
          </tr>
        </template>
      </table>
      <!-- <strong style="cursor: pointer;" @click="item.lead ? openPage('/leads/detail?id=' + item.lead.id + '&page=' + 1) : ''"> {{item.lead.first_name}} {{item.lead.last_name}} </strong>
       <br> {{item.leads_activities_type.name}}
        <br> {{item.leads_activities_status.name}}
          <br> {{item.lead.member? (item.lead.member.membership ? 'Join' : 'Not Join') : 'Not Join'}}

         <br>

         <hr> -->
    </div>
  </div>
</template>
<script>
  export default {
    props:['data'],
    methods: {
      openPage (event) {
        this.$router.push(event)
      },
    },
  }
</script>
